import React from 'react';
import withBaseLayout from '../BaseLayout/withBaseLayout.js';
import Typography from '@material-ui/core/Typography';
import Card, { CardContent } from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import { getString } from '../../helpers/stringHelpers';

function AuthLayout(props) {
	const { classes } = props;
	//You have been logged out of the application.
	return (
		<div className={classes.root}>
			<Card>
				<CardContent>
					<Typography variant='h2' gutterBottom={true}>
						{getString('auth', 'LOGGED_OUT_MESSAGE')}{' '}
						<a href='/auth'>
							{getString('auth', 'LOGIN_LINK_LABEL')}
						</a>
						.
					</Typography>
				</CardContent>
			</Card>
		</div>
	);
}

AuthLayout.propTypes = {};

export default withBaseLayout(withStyles(styles)(AuthLayout));
